export const getTime_api = {
	url: 'maijiaDownloadtime',
	method: 'get'
}

export const getpf_api = {
	url: 'getmaijiaprofession',
	method: 'get'
}

export const getFormworkFile_api = {
	url: 'getFormworkFile',
	method: 'get',
	title: '模板文件列表'
}



// WEBPACK FOOTER //
// ./src/views/maijia/maijia-professionprice/desc.js